/** 底部悬浮提示（对照 HTML .pc-toast） */
let el = null
let timer = null

function ensureEl() {
  if (el) return el
  el = document.createElement('div')
  el.className = 'pc-toast'
  document.body.appendChild(el)
  return el
}

export function toast(message, type) {
  const msg = String(message || '').trim()
  if (!msg) return
  const node = ensureEl()
  node.textContent = msg
  node.classList.remove('show', 'is-ok', 'is-err')
  if (type === 'ok') node.classList.add('is-ok')
  if (type === 'err') node.classList.add('is-err')
  // 强制重绘后再加 show，保证连续弹出也能动画
  // eslint-disable-next-line no-unused-expressions
  node.offsetWidth
  requestAnimationFrame(() => {
    node.classList.add('show')
  })
  clearTimeout(timer)
  timer = setTimeout(() => {
    node.classList.remove('show')
  }, 2400)
}

export function toastOk(message) {
  toast(message, 'ok')
}

export function toastErr(message) {
  toast(message, 'err')
}

export default toast
